import React from "react";
import {
  addClient,
  addImage,
  saveSiteSettings,
} from "../../../../data/serviceClients";
import AccordianTitle from "../../../../helpers/uiComponents/Accordian";
import { ActionTabs } from "../../../../helpers/uiComponents/ActionTabs";
import { InputRow } from "../../../../helpers/uiComponents/InputRow";
import {
  hideMessage,
  showMessage,
} from "../../../../helpers/uiFunctions/uiActions";

class WebsiteConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.save = this.save.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.saveImage = this.saveImage.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.updateCatalogs = this.updateCatalogs.bind(this);
  }
  saveImage() {
    var logoInput = document.getElementById("brand-logo");
    var logo = new FormData();
    var clientCode = this.props.currentClient.clientCode;

    logo.append("logo", logoInput.files[0]);
    //console.log(logo);
    addImage(clientCode, logo).then((response) => {
      //console.log(response);
      var updateClient = this.props.updateClient;
      updateClient("logo", response.result.logo, null);
    });
  }
  deleteImage() {
    var updateClient = this.props.updateClient;
    updateClient("logo", null, null);
  }
  updateCatalogs() {
    var Http = new XMLHttpRequest();
    var url =
      "https://sfn.mm-api.agency/task/catalog/" +
      this.props.currentClient.clientCode;
    Http.open("GET", url);
    Http.send();

    Http.onreadystatechange = (e) => {
      console.log(Http.responseText);
    };
  }
  handleSubBrandUpdateLocally(newSubBrands, fetchName, value) {
    try {
      const fetchJson = JSON.parse(newSubBrands);
      if (Array.isArray(fetchJson)) {
        newSubBrands = [...fetchJson];
      } else {
        newSubBrands = [];
      }
    } catch (error) {
      newSubBrands = [];
    }

    if (value) {
      newSubBrands = [...newSubBrands, fetchName];
    } else {
      newSubBrands = newSubBrands.filter((val) => {
        return String(val).toLowerCase() !== String(fetchName).toLowerCase();
      });
    }

    newSubBrands = JSON.stringify(newSubBrands);
    return newSubBrands;
  }
  handleUpdate(e) {
    var key = e.target.name;
    var value = e.target.value;
    var subArr = null;

    if (key.includes(".")) {
      subArr = key.split(".")[0];
      key = key.split(".")[1];
    }

    var type = e.target.type;
    if (type === "checkbox") {
      value = e.target.checked;
    }

    var updateClient = this.props.updateClient;

    // Handle Brand Page Settings in if
    if (key.includes("shawSubBrands_")) {
      const fetchName = key.split("shawSubBrands_")[1];
      let fetchShawSubBrandsVals =
        this.props.currentClient.options.shawSubBrands || [];
      let newShawSubBrands = this.handleSubBrandUpdateLocally(fetchShawSubBrandsVals, fetchName, value);
      updateClient("shawSubBrands", newShawSubBrands, subArr);
    } else if (key.includes("mohawkSubBrands_")) {
      const fetchName = key.split("mohawkSubBrands_")[1];
      let fetchMohawkSubBrandsVals =
        this.props.currentClient.options.mohawkSubBrands || [];
      let newMohawkSubBrands = this.handleSubBrandUpdateLocally(fetchMohawkSubBrandsVals, fetchName, value);
      updateClient("mohawkSubBrands", newMohawkSubBrands, subArr);
    } else if (key.includes("karastanSubBrands_")) {
      const fetchName = key.split("karastanSubBrands_")[1];
      let fetchKarastanSubBrandsVals =
        this.props.currentClient.options.karastanSubBrands || [];
      let newKarastanSubBrands = this.handleSubBrandUpdateLocally(fetchKarastanSubBrandsVals, fetchName, value);
      updateClient("karastanSubBrands", newKarastanSubBrands, subArr);
    } else if (key.includes("godfreySubBrands_")) {
      const fetchName = key.split("godfreySubBrands_")[1];
      let fetchGodfreySubBrandsVals =
        this.props.currentClient.options.godfreySubBrands || [];
      let newGodfreySubBrands = this.handleSubBrandUpdateLocally(fetchGodfreySubBrandsVals, fetchName, value);
      updateClient("godfreySubBrands", newGodfreySubBrands, subArr);
    } else if (key.includes("pergoSubBrands_")) {
      const fetchName = key.split("pergoSubBrands_")[1];
      let fetchPergoSubBrandsVals =
        this.props.currentClient.options.pergoSubBrands || [];
      let newPergoSubBrands = this.handleSubBrandUpdateLocally(fetchPergoSubBrandsVals, fetchName, value);
      updateClient("pergoSubBrands", newPergoSubBrands, subArr);
    } else if (key.includes("canopyFlooringSubBrands_")) {
      const fetchName = key.split("canopyFlooringSubBrands_")[1];
      let fetchCanopyFlooringSubBrandsVals =
        this.props.currentClient.options.canopyFlooringSubBrands || [];
      let newCanopyFlooringSubBrands = this.handleSubBrandUpdateLocally(fetchCanopyFlooringSubBrandsVals, fetchName, value);
      updateClient("canopyFlooringSubBrands", newCanopyFlooringSubBrands, subArr);
    } else {
      updateClient(key, value, subArr);
    }

    // Make Subbrands empty if parent brand option is false
    if (key === "shawBrandPage" && !value) {
      updateClient("shawSubBrands", JSON.stringify([]), subArr);
    }
    if (key === "mohawkBrandPage" && !value) {
      updateClient("mohawkSubBrands", JSON.stringify([]), subArr);
    }
    if (key === "karastanBrandPage" && !value) {
      updateClient("karastanSubBrands", JSON.stringify([]), subArr);
    }
    if (key === "godfreyBrandPage" && !value) {
      updateClient("godfreySubBrands", JSON.stringify([]), subArr);
    }
    if (key === "pergoBrandPage" && !value) {
      updateClient("pergoSubBrands", JSON.stringify([]), subArr);
    }
    if (key === "canopyFlooringBrandPage" && !value) {
      updateClient("canopyFlooringSubBrands", JSON.stringify([]), subArr);
    }
    // Make Subbrands empty if parent brand option is false

    // updateClient(key, value, subArr);

    if (key === "roomvo" || key === "cloudinary") {
      this.updateCatalogs();

      setTimeout(() => {
        this.save();
      }, 250);
    }
  }
  save() {
    showMessage("Saving Website Configuration...");
    var client = this.props.currentClient;
    delete client.transactions;
    saveSiteSettings(client.clientCode, client.sites[0]).then(() => {
      addClient(this.props.currentClient).then((data) => {
        hideMessage(data.success);
      });
    });
  }
  formatDate(inputDate) {
    const dbDate = new Date(inputDate);
    const timezoneOffset = dbDate.getTimezoneOffset() * 60000; //offset in milliseconds
    const dateObj = new Date(
      dbDate.valueOf() + timezoneOffset * Math.sign(timezoneOffset)
    );

    const getYear = dateObj.getFullYear();
    const getMonth =
      dateObj.getMonth() + 1 > 9
        ? dateObj.getMonth() + 1
        : "0" + (dateObj.getMonth() + 1);
    const getDate =
      dateObj.getDate() > 9 ? dateObj.getDate() : "0" + dateObj.getDate();
    const getHour =
      dateObj.getHours() > 9 ? dateObj.getHours() : "0" + dateObj.getHours();
    const getMinutes =
      dateObj.getMinutes() > 9
        ? dateObj.getMinutes()
        : "0" + dateObj.getMinutes();
    console.log(
      getYear +
        "-" +
        getMonth +
        "-" +
        getDate +
        "T" +
        getHour +
        ":" +
        getMinutes
    );
    return getYear + "-" + getMonth + "-" + getDate;
  }

  fetchExistingSubBrands(existingData = []) {
    try {
      const fetchExistingBrandsJson = JSON.parse(existingData);
      if (Array.isArray(fetchExistingBrandsJson)) {
        return existingData = [...fetchExistingBrandsJson];
      } else {
        return existingData = [];
      }
    } catch (error) {
      return existingData = [];
    }
  }
  render() {
    const currentClient = this.props.currentClient;
    var website = currentClient.sites[0];
    const shawSubBrands = [
      { name: "anso_colorwall", label: "Anso Colorwall" },
      { name: "pet_perfect", label: "Pet Perfect" },
      { name: "anderson_tuftex", label: "Anderson Tuftex" },
      { name: "coretec", label: "COREtec" },
      { name: "floorte", label: "Floorte" },
      { name: "philadelphia_commercial", label: "Philadelphia Commercial" },
      { name: "shaw_grass", label: "Shaw Grass" },
    ];

    const mohawkSubBrands = [
      { name: "mohawk_smartstrand", label: "Mohawk SmartStrand" },
      { name: "mohawk_everstrand", label: "Mohawk EverStrand" },
      { name: "mohawk_petpremier", label: "Mohawk PETPremier" },
      { name: "mohawk_revwood", label: "Mohawk RevWood" },
      { name: "mohawk_solidtech", label: "Mohawk SolidTech" },
      { name: "mohawk_solidtech_r", label: "Mohawk SolidTech R" },
      { name: "mohawk_puretech", label: "Mohawk PureTech" },
      { name: "mohawk_airo", label: "Mohawk AirO" },
      { name: "mohawk_tecwood", label: "Mohawk TecWood" },
      { name: "mohawk_ultimateflex", label: "Mohawk UltimateFlex" },
    ];

    // Karastan Sub Brands
    const karastanSubBrands = [
      { name: "karastan_smartstrand", label: "Karastan SmartStrand" },
      { name: "karastan_luxecraft", label: "Karastan LuxeCraft" },
      { name: "karastan_belleluxe", label: "Karastan BelleLuxe" },
      { name: "belleluxe_natural", label: "Belleluxe Natural" },
      { name: "black_label", label: "Black Label" },
      { name: "belleluxe_waterproof", label:"BelleLuxe Waterproof"},
    ];

    const godfreySubBrands = [
      { name: "godfrey_hirst_Smartstrand", label: "Godfrey Hirst SmartStrand" },
      { name: "godfrey_hirst_wool", label: "Godfrey Hirst Wool" },
      { name: "godfrey_hirst_everLux", label: "Godfrey Hirst EverLux" },
    ];

    const pergoSubBrands = [
      { name: "pergo_elements", label: "Pergo Elements" },
      { name: "pergo_extreme", label: "Pergo Extreme" },
    ];

    const canopyFlooringSubBrands = [
      { name: "canopy_flooring", label: "Canopy Flooring" },
    ];

    let existingShawSubBrands = this.fetchExistingSubBrands(currentClient.options.shawSubBrands) || [];
    let existingMohawkSubBrands = this.fetchExistingSubBrands(currentClient.options.mohawkSubBrands) || [];
    let existingKarastanSubBrands =
      this.fetchExistingSubBrands(currentClient.options.karastanSubBrands) || [];
    let existingGodfreySubBrands = this.fetchExistingSubBrands(currentClient.options.godfreySubBrands) || [];
    let existingPergoSubBrands = this.fetchExistingSubBrands(currentClient.options.pergoSubBrands) || [];
    let existingCanopyFlooringSubBrands = this.fetchExistingSubBrands(currentClient.options.canopyFlooringSubBrands) || [];
    
    
    return (
      <div className="input-group">
        <AccordianTitle title={"Website Configuration"} />
        <div className="accordian-body">
          <ActionTabs handleSave={this.save} id={"webConfig"} />
          <div id="webConfig-inputs" className="inputs">
            <h5>Website Branding</h5>
            <div className="input-row">
              <label htmlFor="logo">Brand Logo</label>
              <div>
                <input
                  type="file"
                  name="logo"
                  id="brand-logo"
                  onChange={() => this.saveImage()}
                  filename={currentClient.logo}
                />
                <p>Max Image Size is 1MB, All images should be .jpg or .png</p>
                {currentClient.logo && (
                  <div className="image-container">
                    <img
                      src={"https://" + currentClient.logo}
                      alt={currentClient.name}
                      id="img-logo"
                    />
                    <p>src="https://{currentClient.logo}"</p>
                    <div className="delete-img">
                      <i
                        className="fas fa-times icon"
                        onClick={() => this.deleteImage()}
                      ></i>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <InputRow
              onChange={this.handleUpdate}
              label="Primary Color"
              type="color"
              value={currentClient.color1}
              property="color1"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Secondary Color"
              type="color"
              value={currentClient.color2}
              property="color2"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Other Color"
              type="color"
              value={currentClient.color3}
              property="color3"
            />

            <h5>Financing Service Links</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="Wells Fargo Financing Link"
              type="text"
              value={currentClient.financeWF}
              property="financeWF"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Synchrony Financing Link"
              type="text"
              value={currentClient.financeSync}
              property="financeSync"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Generic Financing Page"
              type="checkbox"
              value={currentClient.financeGeneric}
              property="financeGeneric"
              description={
                "For FRANCHISE websites only. displays a generic financing page and top nav link."
              }
            />

            <h5>Site Content</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="About Us Copy Block"
              type="textarea"
              value={website.aboutUs}
              property="sites.aboutUs"
            />

            <h5>Blog Settings</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="Allow Blog Assignments?"
              type="checkbox"
              value={currentClient.options.allowBlogs}
              property="options.allowBlogs"
            />

            <h5>CIPA Settings</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="Activate CIPA?"
              type="checkbox"
              value={currentClient.options.allowCIPA}
              property="options.allowCIPA"
            />

            <h5>Samples Store Settings</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="Samples Store Manufacturers"
              type="text"
              value={currentClient.options.sampleManufacturers}
              property="options.sampleManufacturers"
            />

            {currentClient.velocity && (
              <React.Fragment>
                <h5>Velocity Content</h5>
                <InputRow
                  onChange={this.handleUpdate}
                  label="Colorwall Exclusive Products & Content?"
                  type="checkbox"
                  value={currentClient.options.colorWall}
                  property="options.colorWall"
                />
              </React.Fragment>
            )}

            {/* Brand configuration new one */}
            <h5>Brand Page Settings</h5>
            {/* Shaw Brand page */}
            <div className="brand-check-wrap shaw-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Shaw"
                type="checkbox"
                value={currentClient.options.shawBrandPage}
                property="options.shawBrandPage"
              />
            </div>
            {currentClient.options.shawBrandPage !== undefined &&
            String(currentClient.options.shawBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {shawSubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingShawSubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.shawSubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Shaw Brand page */}
            {/* Mohawk Brand page */}
            <div className="brand-check-wrap mohawk-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Mohawk"
                type="checkbox"
                value={currentClient.options.mohawkBrandPage}
                property="options.mohawkBrandPage"
              />
            </div>
            {currentClient.options.mohawkBrandPage !== undefined &&
            String(currentClient.options.mohawkBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {mohawkSubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingMohawkSubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.mohawkSubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Mohawk Brand page */}
            {/* Karastan Brand page */}
            <div className="brand-check-wrap mohawk-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Karastan"
                type="checkbox"
                value={currentClient.options.karastanBrandPage}
                property="options.karastanBrandPage"
              />
            </div>
            {currentClient.options.karastanBrandPage !== undefined &&
            String(currentClient.options.karastanBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {karastanSubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingKarastanSubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.karastanSubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Karastan Brand page */}
            {/* Godfrey Brand page */}
            <div className="brand-check-wrap mohawk-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Godfrey"
                type="checkbox"
                value={currentClient.options.godfreyBrandPage}
                property="options.godfreyBrandPage"
              />
            </div>
            {currentClient.options.godfreyBrandPage !== undefined &&
            String(currentClient.options.godfreyBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {godfreySubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingGodfreySubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.godfreySubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Godfrey Brand page */}
            {/* Pergo Brand page */}
            <div className="brand-check-wrap mohawk-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Pergo"
                type="checkbox"
                value={currentClient.options.pergoBrandPage}
                property="options.pergoBrandPage"
              />
            </div>
            {currentClient.options.pergoBrandPage !== undefined &&
            String(currentClient.options.pergoBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {pergoSubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingPergoSubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.pergoSubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Pergo Brand page */}
            {/* Canopy Flooring */}
            <div className="brand-check-wrap mohawk-main-checkbox">
              <InputRow
                onChange={this.handleUpdate}
                label="Canopy Flooring"
                type="checkbox"
                value={currentClient.options.canopyFlooringBrandPage}
                property="options.canopyFlooringBrandPage"
              />
            </div>
            {currentClient.options.canopyFlooringBrandPage !== undefined &&
            String(currentClient.options.canopyFlooringBrandPage).toLowerCase() ===
              "true" ? (
              <div className="sub-brands-wrapper">
                {canopyFlooringSubBrands.map((brand) => {
                  let itemVal = 0;
                  if (existingCanopyFlooringSubBrands.includes(brand.name)) {
                    itemVal = 1;
                  }
                  return (
                    <InputRow
                      onChange={this.handleUpdate}
                      label={brand.label}
                      type="checkbox"
                      value={itemVal}
                      key={brand.name}
                      property={"options.canopyFlooringSubBrands_" + brand.name}
                    />
                  );
                })}
              </div>
            ) : null}
            {/* Canopy Flooring */}
            {/* Brand configuration new one */}
            <h5>
              Franchise Content{" "}
              {currentClient.franchiseName
                ? "- " + currentClient.franchiseName
                : "- franchise not set"}
            </h5>
            <p>
              Set the franchise in Franchise Management. Options specific to the
              franchise will display below.{" "}
            </p>
            {currentClient.franchiseName === "floorsToCeiling" && (
              <React.Fragment>
                <h4>Shop at home</h4>
                <InputRow
                  onChange={this.handleUpdate}
                  label="Does this website have Shop At Home?"
                  type="checkbox"
                  value={currentClient.options.shopAtHome}
                  property="options.shopAtHome"
                  description="updates content on home page and product detail page"
                />
                <h4>Categorys</h4>
                <InputRow
                  onChange={this.handleUpdate}
                  label="Kitchen & Bath Category"
                  type="checkbox"
                  value={currentClient.options.kitchenBath}
                  property="options.kitchenBath"
                />
                {(currentClient.options.kitchenBath === 1 ||
                  currentClient.options.kitchenBath === "1" ||
                  currentClient.options.kitchenBath === true) && (
                  <React.Fragment>
                    <InputRow
                      onChange={this.handleUpdate}
                      label="Kitchen & Bath - Countertops Category"
                      type="checkbox"
                      value={currentClient.options.kitchenBathCountertop}
                      property="options.kitchenBathCountertop"
                    />
                    <InputRow
                      onChange={this.handleUpdate}
                      label="Kitchen & Bath - Cabinets Category"
                      type="checkbox"
                      value={currentClient.options.kitchenBathCabinet}
                      property="options.kitchenBathCabinet"
                    />
                    <InputRow
                      onChange={this.handleUpdate}
                      label="Kitchen & Bath - Vanities Category"
                      type="checkbox"
                      value={currentClient.options.kitchenBathVanity}
                      property="options.kitchenBathVanity"
                    />
                    <InputRow
                      onChange={this.handleUpdate}
                      label="Kitchen & Bath - Hardware Category"
                      type="checkbox"
                      value={currentClient.options.kitchenBathHardware}
                      property="options.kitchenBathHardware"
                    />
                  </React.Fragment>
                )}
                <InputRow
                  onChange={this.handleUpdate}
                  label="Window Treatments Category"
                  type="checkbox"
                  value={currentClient.options.windowTreatment}
                  property="options.windowTreatment"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Carpet Category"
                  type="checkbox"
                  value={currentClient.options.carpetLanding}
                  property="options.carpetLanding"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Hardwood Category"
                  type="checkbox"
                  value={currentClient.options.hardwoodLanding}
                  property="options.hardwoodLanding"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Laminate Category"
                  type="checkbox"
                  value={currentClient.options.laminateLanding}
                  property="options.laminateLanding"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Vinyl Category"
                  type="checkbox"
                  value={currentClient.options.vinylLanding}
                  property="options.vinylLanding"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Tile Category"
                  type="checkbox"
                  value={currentClient.options.tileLanding}
                  property="options.tileLanding"
                />
                <InputRow
                  onChange={this.handleUpdate}
                  label="Area Rugs Category"
                  type="checkbox"
                  value={currentClient.options.areaRugsLanding}
                  property="options.areaRugsLanding"
                />
              </React.Fragment>
            )}

            <h5>Misc Settings & Services</h5>
            <InputRow
              onChange={this.handleUpdate}
              label="Use Roomvo"
              type="checkbox"
              value={website.roomvo}
              property="sites.roomvo"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Use Cloudinary"
              type="checkbox"
              value={website.cloudinary}
              property="sites.cloudinary"
            />
            {website.cloudinary === true && (
              <InputRow
                label="Cloudinary Cloud Name"
                type="select"
                value={website.imgCloud}
                property="sites.imgCloud"
                id="imgCloud"
                hideSelectOption="true"
                options={[
                  { name: "mobilemarketing", value: "mobilemarketing" },
                  { name: "fliq", value: "fliq" },
                ]}
                onChange={this.handleUpdate}
              />
            )}
            <InputRow
              onChange={this.handleUpdate}
              label="Activate Accessibe"
              type="checkbox"
              value={website.accessibe}
              property="sites.accessibe"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Chatmeter Script"
              type="textarea"
              value={website.chatmeter}
              property="sites.chatmeter"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Custom Alert Banner"
              type="textarea"
              value={website.banner}
              property="sites.banner"
              description="use the Primary Color selector above to set the color of this banner"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Banner Override Text"
              type="textarea"
              value={website.bannerOverrideText}
              property="sites.bannerOverrideText"
              description="use the Primary Color selector above to set the color of this banner"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Banner Start Date"
              type="date"
              value={this.formatDate(website.bannerStartDate)}
              property="sites.bannerStartDate"
            />
            <InputRow
              onChange={this.handleUpdate}
              label="Banner End Date"
              type="date"
              value={this.formatDate(website.bannerEndDate)}
              property="sites.bannerEndDate"
            />

            {/* bannerStartDate
                        bannerEndDate */}
          </div>
        </div>
      </div>
    );
  }
}
export default WebsiteConfig;



// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/WebsiteConfiguration.js